import axios from "axios";
import Env from '../runtimeEnv';

const API_URL = Env.REACT_APP_PYTHON_API_URL;

// Create an Axios instance with global settings
const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Ensures cookies (including refresh_token) are sent
});

// Refresh the HttpOnly access-token cookie without exposing the token to JavaScript.
let refreshInFlight = null;
let authRedirectInProgress = false;
const refreshAccessToken = () => {
  // Returning to the menu starts several requests at once. Share one refresh
  // so an expired session does not trigger competing cookie updates.
  if (!refreshInFlight) {
    refreshInFlight = axios.post(`${API_URL}/api/refresh-token`, {}, { withCredentials: true })
      .then((response) => response.status === 200)
      .catch(() => false)
      .finally(() => { refreshInFlight = null; });
  }
  return refreshInFlight;
};

const redirectToLoginOnce = () => {
  if (authRedirectInProgress) return;
  authRedirectInProgress = true;

  // A failed cookie refresh means the locally cached identity is stale. Clear
  // it before reloading so App cannot restore an authenticated screen and
  // immediately repeat the same protected request/401/refresh cycle.
  localStorage.removeItem("currentNickname");
  localStorage.removeItem("PlutonicuserID");
  localStorage.removeItem("userType");
  localStorage.removeItem("userEmail");
  localStorage.removeItem("email");
  localStorage.removeItem("surveyCompleted");
  localStorage.removeItem("access_token");
  localStorage.removeItem("lastVisitedPage");
  localStorage.removeItem("lastActiveTime");
  sessionStorage.clear();

  window.location.replace("/");
};

// Axios response interceptor to handle expired tokens
axiosInstance.interceptors.response.use(
  (response) => response, // ✅ Pass successful responses
  async (error) => {
    if (error.response?.status === 401 && !error.config?._refreshAttempted) {
      error.config._refreshAttempted = true;
      const refreshed = await refreshAccessToken();

      if (refreshed) {
        return axiosInstance(error.config);
      } else {
        redirectToLoginOnce();
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
